export const OPTION_ALL_VALUE = ""
export const OPTION_ALL_LABEL = "Tất cả"
export const GUIDE_EMPTY = "00000000-0000-0000-0000-000000000000"

export const FAILBACK =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="

export const START_BASE64 = "data:application/force-download;base64,"
export const START_BASE64_IMG_JPG = "data:image/jpeg;base64,"

export const STATUS_POST = [
  "",
  "#ff7875",
  "#40a9ff",
  "#52c41a",
  "#094ad9",
  "#ff9f40",
]

export const ACRONYM = ["tnhh", "shtt"]

export const COLOR_STATUS = ["#ff4d4f", "#0d99ff"]

export const SYSTEM_KEY = {
  SIGN_STATUS: "SIGN_STATUS",
  STATUS_CERTIFICATE: "STATUS_CERTIFICATE",
  TEMPLATE_FILE_CHECK_PAYMENT_STATUS: "TEMPLATE_FILE_CHECK_PAYMENT_STATUS",
  WARNING_MESSAGE: "WARNING_MESSAGE",
  PAYMENT_PLATFORM: "PAYMENT_PLATFORM",
  HINH_THUC_NOP: "HINH_THUC_NOP",
  BCLIST: "BCLIST",
  DEPOSIT_REQUEST_STATUS: "DEPOSIT_REQUEST_STATUS",
  REASON_RE_CERTIFICATION: "REASON_RE_CERTIFICATION",
  RECEIPT_MODIFY_TYPE: "RECEIPT_MODIFY_TYPE",
  FIELDS_PRACTICE: "FIELDS_PRACTICE",
  TIEP_NHAN_DON_TRUC_TUYEN: "TIEP_NHAN_DON_TRUC_TUYEN",
  TYPE_CHECK_REGISTER: "TYPE_CHECK_REGISTER",
  TYPE_CONTACT: "TYPE_CONTACT",
  ACCOUNT_TYPE: "ACCOUNT_TYPE",
  STATUS_HAVE_ACCOUNT: "STATUS_HAVE_ACCOUNT",
  LY_DO_HUY_BL: "LY_DO_HUY_BL",
  FEE_TYPE_PHI_LE_PHI: "FEE_TYPE_PHI_LE_PHI",
  VALID_DECISION: "VALID_DECISION",
  QUOC_GIA: "QUOC_GIA",
  LOAI_NGUOI_NOP_DON: "LOAI_NGUOI_NOP_DON",
  DON_VI_TINH: "DON_VI_TINH",
  LOAI_TAI_LIEU: "LOAI_TAI_LIEU",
  THOI_HAN_BAO_QUAN: "THOI_HAN_BAO_QUAN",
  HOP_SO: "HOP_SO",
  DON_VI: "DON_VI",
  MA_TAI_LIEU: "MA_TAI_LIEU",
  LOAI_BIEN_DONG: "LOAI_BIEN_DONG",
  DOCUMENT_EXTRACTION: "DOCUMENT_EXTRACTION",
  REQUEST_DATA_USAGE_STATUS: "REQUEST_DATA_USAGE_STATUS",
  THOI_HAN_SD: "THOI_HAN_SD",
  CHE_DO_SD: "CHE_DO_SD",
  MUC_DICH_SD_DAT: "MUC_DICH_SD_DAT",
  LINH_VUC: "LINH_VUC",
  STATUS_HO_SO: "STATUS_HO_SO",
  LOAI_DAT: "LOAI_DAT",
  NGON_NGU: "NGON_NGU",
  DO_MAT: "DO_MAT",
  INVOICE_PAYMENT_TYPE: "INVOICE_PAYMENT_TYPE",
  DOSSIER_FORMUSE: "DOSSIER_FORMUSE",
  DOSSIER_PURPOSEUSE: "DOSSIER_PURPOSEUSE",
  DOSSIER_NETWORK: "DOSSIER_NETWORK",
  DOSSIER_FILE_TYPE: "DOSSIER_FILE_TYPE",
  DOSSIER_STATUS: "DOSSIER_STATUS",
  DOSSIER_GROUP_STATUS: "DOSSIER_GROUP_STATUS",
  SYNC_STATUS: "SYNC_STATUS",
  DOSSIER_PAYMENT: "DOSSIER_PAYMENT",
  STATUS_RECEIPT: "STATUS_RECEIPT",
  STATUS_PBT: "STATUS_PBT",
  DOSSIER_OFF_STATUS: "DOSSIER_OFF_STATUS",
  FILE_IMPORT_SAMPLE_TEST_QUESTION: "FILE_IMPORT_SAMPLE_TEST_QUESTION",
  COURSE_STATUS: "COURSE_STATUS",
  COURSE_LEARN_FORM: "COURSE_LEARN_FORM",
  SEX_TYPE: "SEX_TYPE",
  COMMON_STATUS: "COMMON_STATUS",
  ACCOUNT_STATUS: "ACCOUNT_STATUS",
  BUSINESS_AREAS: "BUSINESS_AREAS",
  POST_STATUS: "POST_STATUS",
  AUTHORIZEDUSERFIELD_TYPE: "AUTHORIZEDUSERFIELD_TYPE",
  FIELD_NUMBER: "FIELD_NUMBER",
  SUBMIT_SUPPORT_REQUEST_STATUS: "SUBMIT_SUPPORT_REQUEST_STATUS",
  COURSE_PRICE_TYPE: "COURSE_PRICE_TYPE",
  PRICE_BIDDING: "PRICE_BIDDING",
  QUALITY_SERVICE: "QUALITY_SERVICE",
  SATUS_POST_BIDDING: "SATUS_POST_BIDDING",
  ACADEMIC_LEVEL: "ACADEMIC_LEVEL",
  RANK: "RANK",
  CAREER_LEVEL: "CAREER_LEVEL",
  WAGE_TYPE: "WAGE_TYPE",
  WORKING_FORM: "WORKING_FORM",
  WELFARE: "WELFARE",
  DEGREE: "DEGREE",
  PRESENTATION_LANGUAGE: "PRESENTATION_LANGUAGE",
  FORM_WORKING: "FORM_WORKING",
  NUMBER_STAFF: "NUMBER_STAFF",
  NUMBER_EXP_YEAR: "NUMBER_EXP_YEAR",
  CAP_SO_DON: "CAP_SO_DON",
  DANH_SACH_CONG_VAN: "DANH_SACH_CONG_VAN",
  PHI_BO_SUNG: "PHI_BO_SUNG",
  QUAN_TRI: "QUAN_TRI",
  CAC_MON_THUOC_CHUYEN_NGANH_GIAM_DINH_DANG_KY:
    "CAC_MON_THUOC_CHUYEN_NGANH_GIAM_DINH_DANG_KY",
  DOSSIER_PROCEDURE_TYPE: "DOSSIER_PROCEDURE_TYPE",
  GRANT_APPLICATION_NUMBER: "GRANT_APPLICATION_NUMBER",
  DOSSIER_PROVIDE: "DOSSIER_PROVIDE",
  DOSSIER_INTERNATIONAL: "DOSSIER_INTERNATIONAL",
  DOSSIER_INTERNATIONAL_B: "DOSSIER_INTERNATIONAL_B",
  APP_RELATED_APP: "APP_RELATED_APP",
  DOSSIER_VAN_BANG: "DOSSIER_VAN_BANG",
  OTHER_APPLICATIONS: "OTHER_APPLICATIONS",
  SUBMISSION_STATUS: "SUBMISSION_STATUS",
  FILE_DINH_KEM: "FILE_DINH_KEM",
  TAI_LIEU: "TAI_LIEU",
  PHI: "PHI",
  CH_MA_DON_VI: "CH_MA_DON_VI",
  CH_BIEN_LAI: "CH_BIEN_LAI",
  PHI_BS_KHAC: "PHI_BS_KHAC",
  CAU_HINH_QR_THANH_TOAN: "CAU_HINH_QR_THANH_TOAN",
  CAU_HINH_KI_SO: "CAU_HINH_KI_SO",
  HINH_THUC_NOP_DON: "HINH_THUC_NOP_DON",
  NGAN_HANG: "NGAN_HANG",
  TEMPLATE_FILE_IMPORT_POSITION: "TEMPLATE_FILE_IMPORT_POSITION",
  TEMPLATE_DOSSIER_SIGN_RESULT: "TEMPLATE_DOSSIER_SIGN_RESULT",
  TEMPLATE_FILE_IMPORT_USER: "TEMPLATE_FILE_IMPORT_USER",
  TEMPLATE_FILE_IMPORT_DEPARTMENT: "TEMPLATE_FILE_IMPORT_DEPARTMENT",
  TEMPLATE_FILE_IMPORT_SYSTEM_CATE: "TEMPLATE_FILE_IMPORT_SYSTEM_CATE",
  TEMPLATE_IMPORT_DOSSIER: "TEMPLATE_IMPORT_DOSSIER",
  TEMPLATE_FILE_IMPORT_DOSSIER_FILE: "TEMPLATE_FILE_IMPORT_DOSSIER_FILE",
  OTHER_FEE_SC: "OTHER_FEE_SC/GPHI",
  OTHER_FEE_KDCN: "OTHER_FEE_KDCN",
  OTHER_FEE_NH: "OTHER_FEE_NH",
  TRADEMARK_TYPE: "TRADEMARK_TYPE",
  REPORT_STATUS: "REPORT_STATUS",
  ACCOUNT_REPORT: "ACCOUNT_REPORT",
  FEE_TYPE: "FEE_TYPE",
  FEES_TYPE: "FEES_TYPE",
  INVOICE_PAYMENT_STATUS: "INVOICE_PAYMENT_STATUS",
  STATUS_RECEIPT_OFF: "STATUS_RECEIPT_OFF",
  FUND_STATUS: "FUND_STATUS",
  TYPE_QUY: "TYPE_QUY",
  PAYMENT_TYPE: "PAYMENT_TYPE",
  BCTH: "BCTH",
  BCCT: "BCCT",
  TT263_LEPHI_CATEGORY: "TT263_LEPHI_CATEGORY",
  TT263_PHI_CATEGORY: "TT263_PHI_CATEGORY",
  LINK_FILE_HUONGDAN: "LINK_FILE_HUONGDAN",
  FORMAT_POST_CODE: "FORMAT_POST_CODE",
  REPRESENT_STATUS: "REPRESENT_STATUS",
  DOSSIER_CB: "DOSSIER_CB",
  EMAIL_STATUS: "EMAIL_STATUS",
  SEND_TYPE: "SEND_TYPE",
}
export const ACCOUNT_TYPE_ID = {
  KH_CA_NHAN: 2,
  KH_TO_CHUC: 3,
  TO_CHUC_DAI_DIEN: 1,
  NGUOI_DAI_DIEN: 4,
  CHUYEN_VIEN: 6,
  ADMIN: 9,
}
export const ROLE_NAME = [
  {
    title: "Tổ chức đại diện",
    value: 1,
  },
  {
    title: "Khách hàng cá nhân",
    value: 2,
  },
  {
    title: "Khách hàng tổ chức",
    value: 3,
  },
  {
    title: "Cá nhân đại diện",
    value: 4,
  },
  {
    title: "Chuyên viên",
    value: 6,
  },
  {
    title: "Quản trị hệ thống",
    value: 9,
  },
]
export const COLOR_STATUS_HO_SO = [
  "",
  "#32eb53",
  "#ff9800",
  "#f44336",
  "#2B91EA",
]

export const ACCOUNT_TYPE_ADMIN = [6, 9]
export const ACCOUNT_TYPE_KH = [2, 3]
export const ACCOUNT_TYPE_DAI_DIEN = [1, 4]
export const ACCOUNT_TYPE_TO_CHUC_DAI_DIEN = [1]

// export const COLOR_STATUS_HO_SO = ["", "#0D9D57", "#CE3135", "#CE3135"]

export const RATE_DESC = ["Rất tệ", "Tệ", "Bình thường", "Tốt", "Tuyệt vời"]

export const TYPE_LINK = {
  IMAGE_LINK: 1,
  VIDEO_LINK: 2,
  DOCUMENT_LINK: 3,
  COMPRESSION_LINK: 4,
}

export const STATUS_PAY = [
  "",
  "Chưa thanh toán",
  "Chờ xác nhận",
  "Đã xác nhận",
  "Lỗi giao dịch",
  "Có biên lai",
]

export const COLOR_STATUS_PAY = [
  "",
  "#434343",
  "#FF720D",
  // "#389e0d",
  "#5b8c00",
  "#f5222d",
  "#0958d9",
]
export const COLOR_RECEIPT_PAY = [
  "#434343",
  "#FF720D",
  "#5b8c00",
  "#f5222d",
  "#0958d9",
]

export const VN_CODE = "VN"

export const IP_Check = window.env?.IP_Check || "192.168."
